import { Component, KEY_ESCAPE, element as $, services } from '@contorion/core';
import { IResponse as DemoupResponse } from '../interfaces/demoup-response.interface';
import { VideoService } from '../services/video.service';
import { IVivianService } from '../../vivian/interfaces/vivian-service.interface';
import { stringify } from 'qs';

const VIDEO_CONTAINER_SELECTOR: string = '.js-video-container';
const OPEN_BUTTON_SELECTOR: string = '.js-open-video';
const CLOSE_BUTTON_SELECTOR: string = '.js-video-close';
const HIDDEN_CLASS: string = 'hidden';

export class VideoComponent extends Component {
    protected videoService: VideoService;
    protected vivianService: IVivianService;
    protected iframeUrl: string;
    protected iframe: HTMLIFrameElement;

    protected get openButton(): HTMLElement {
        return <HTMLElement> $(OPEN_BUTTON_SELECTOR);
    }

    protected get closeButton(): HTMLElement {
        return <HTMLElement> $(CLOSE_BUTTON_SELECTOR, this.element);
    }

    protected get videoContainer(): HTMLElement {
        return <HTMLElement> $(VIDEO_CONTAINER_SELECTOR, this.element);
    }

    protected get demoupURL(): string {
        return this.element.dataset.videoUrl;
    }

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    protected async init(): Promise<void> {
        this.videoService = await services.get('video-service');
        this.vivianService = await services.get('vivian-service');
        this.loadVideo();
        this.element.addEventListener('loadVideo', this.loadVideo.bind(this));
        this.listenIframeFocus();
    }

    protected async loadVideo(): Promise<void> {
        const demoUpResponse: DemoupResponse = await this.videoService.getVideo(this.demoupURL);

        this.handleResponse(demoUpResponse);
    }

    protected buildIframe(): void {
        this.iframe = document.createElement('iframe');
        this.iframe.src = this.iframeUrl;
        this.iframe.width = '100%';
        this.iframe.frameBorder = '0';
        this.iframe.allowFullscreen = true;
    }

    protected appendIframe(): void {
        this.videoContainer.appendChild(this.iframe);
    }

    protected removeIframe(): void {
        this.videoContainer.innerHTML = '';
    }

    protected handleResponse(response: DemoupResponse): void {
        if (window.tc_vars) {
            window.tc_vars.product_has_video = response.success;
        }

        if (!response.success) {
            return;
        }

        this.iframeUrl = response.iframeURL;
        this.openButton.classList.remove(HIDDEN_CLASS);
        this.openButton.addEventListener('click', this.onOpenButton.bind(this));
        this.element.addEventListener('click', this.onClick.bind(this));
        document.addEventListener('keyup', this.onKeyUp.bind(this));
    }

    protected onOpenButton(): void {
        this.openVideo();
    }

    protected onClick(e: MouseEvent): void {
        e.preventDefault();
        e.stopPropagation();

        if (e.target === this.element || e.target === this.closeButton) {
            this.closeVideo();
        }
    }

    protected onKeyUp(e: KeyboardEvent): void {
        if (e.keyCode !== KEY_ESCAPE) {
            return;
        }

        this.closeVideo();
    }

    protected openVideo(): void {
        this.buildIframe();
        this.appendIframe();
        this.element.classList.remove(HIDDEN_CLASS);
    }

    protected closeVideo(): void {
        this.element.classList.add(HIDDEN_CLASS);
        this.removeIframe();
    }

    protected listenIframeFocus(): void {
        window.focus();
        window.addEventListener('blur', this.trackIframeFocus.bind(this));
    }

    protected trackIframeFocus() {
        if (document.activeElement === document.querySelector('iframe')) {
            this.vivianService.track(stringify({vct: 'pd_img_vid'}), 'product-video-playback');
        }
    }
}
